import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Mail, ShieldCheck } from "lucide-react";

const SUPPORT_EMAIL = "soporte@cadii.app";
const LEGAL_ENTITY = "Multigoods Inmuebles, S. de R.L. de C.V.";

export default function Contact() {
  return (
    <div className="min-h-screen bg-[#F9FAFB]" data-testid="contact-page">
      <Helmet>
        <title>Contact · CADii</title>
        <meta
          name="description"
          content={`Contact CADii — a platform operated by ${LEGAL_ENTITY}.`}
        />
      </Helmet>

      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link
          to="/"
          className="text-[#1B4D3E] font-semibold text-sm hover:underline"
          data-testid="contact-home-link"
        >
          ← Volver
        </Link>

        <div className="mt-6">
          <h1 className="text-3xl sm:text-4xl font-black text-[#102E32]">Contact</h1>
          <p className="text-base text-[#475569] mt-3 leading-relaxed">
            Póngase en contacto con nosotros. Get in touch with the team behind CADii.
          </p>
        </div>

        {/* Legal identity card — visible without login for business verification. */}
        <div
          className="mt-8 rounded-2xl bg-white border border-[#E5E7EB] shadow-sm p-6"
          data-testid="contact-legal-card"
        >
          <div className="flex items-center gap-3 mb-3">
            <div className="w-11 h-11 rounded-xl bg-[#1B4D3E]/10 flex items-center justify-center">
              <ShieldCheck className="w-5 h-5 text-[#1B4D3E]" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-wide text-[#64748B]">Legal entity</p>
              <p className="text-lg font-bold text-[#102E32]">CADii</p>
            </div>
          </div>
          <p className="text-sm text-[#475569] leading-relaxed">
            <strong className="text-[#102E32]">Operated by {LEGAL_ENTITY}</strong>
            <br />
            CADii es operado por <strong className="text-[#102E32]">{LEGAL_ENTITY}</strong>.
          </p>
          <p className="text-xs text-[#64748B] mt-3">
            Brand: CADii · Website:{" "}
            <a
              href="https://www.cadii.app"
              className="text-[#1B4D3E] hover:underline"
              data-testid="contact-website-link"
            >
              https://www.cadii.app
            </a>
          </p>
        </div>

        {/* Contact card — reuse the only confirmed contact channel in the project. */}
        <div
          className="mt-4 rounded-2xl bg-white border border-[#E5E7EB] shadow-sm p-6"
          data-testid="contact-email-card"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-11 h-11 rounded-xl bg-[#1B4D3E]/10 flex items-center justify-center">
              <Mail className="w-5 h-5 text-[#1B4D3E]" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-wide text-[#64748B]">Email de contacto</p>
              <a
                href={`mailto:${SUPPORT_EMAIL}`}
                className="text-lg font-bold text-[#102E32] hover:text-[#1B4D3E]"
                data-testid="contact-email-link"
              >
                {SUPPORT_EMAIL}
              </a>
            </div>
          </div>
          <p className="text-sm text-[#475569]">
            Escríbenos con tu duda, problema o sugerencia. Respondemos en menos de 48 horas hábiles.
          </p>
        </div>

        {/* Legal footer links */}
        <div className="mt-10 flex flex-wrap gap-4 text-sm text-[#64748B]">
          <Link to="/privacy" className="hover:text-[#1B4D3E] hover:underline" data-testid="contact-privacy-link">
            Privacy Policy
          </Link>
          <span>·</span>
          <Link to="/terms" className="hover:text-[#1B4D3E] hover:underline" data-testid="contact-terms-link">
            Terms of Service
          </Link>
          <span>·</span>
          <Link to="/support" className="hover:text-[#1B4D3E] hover:underline" data-testid="contact-support-link">
            Support / FAQ
          </Link>
        </div>

        <p className="mt-12 text-xs text-[#94A3B8]">
          © {new Date().getFullYear()} {LEGAL_ENTITY}. CADii y CADii Golf son marcas operadas por {LEGAL_ENTITY}.
        </p>
      </div>
    </div>
  );
}
